import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="deposit"
export default class extends Controller {
  static targets = ["balance"]

  connect() {
  }

  inputAmount(event) {
    this.balanceTarget.value = parseInt(event.currentTarget.value) * 10
  }
}
